import type { ApiV2SettingsCallbackFormat } from '@/data/models/domain/service/api/types'
import type { TmWrappers } from '@/wrappers'

export const apiV2KeysCreateModalId: TmWrappers = 'apiV2KeysCreateModal'

export type apiV2KeysCreateFormSchema = {
  appName: string
}

export const API_V1_KEY_MODAL_ID: TmWrappers = 'apiV1KeyModal'
export const API_V1_URL_TEST_MODAL_ID: TmWrappers = 'apiV1UrlTestModal'
export const API_V2_URL_TEST_MODAL_ID: TmWrappers = 'apiV2UrlTestModal'

export type ApiV1KeyFormSchema = {
  password: string
}

export type ApiSettingsTestType = 'in' | 'out'

export type ApiSettingsTestCallbackUrlFormat = ApiV2SettingsCallbackFormat
export type ApiSettingsTestCallbackUrlType = ApiSettingsTestType
export type ApiSettingsTestCallbackUrlApiVersion = 'v1' | 'v2'

export interface ApiSettingsTestCallbackUrlBody {
  apiVersion: ApiSettingsTestCallbackUrlApiVersion
  url: string
  type: ApiSettingsTestCallbackUrlType
}

export interface ApiV1SettingsTestCallbackUrlBody extends ApiSettingsTestCallbackUrlBody {
  apiVersion: 'v1'
}

export interface ApiV2SettingsTestCallbackUrlBody extends ApiSettingsTestCallbackUrlBody {
  apiVersion: 'v2'
  format: ApiSettingsTestCallbackUrlFormat
}

export type ApiSettingsTestCallbackUrlRequest = {
  url: string
  type: ApiSettingsTestCallbackUrlType
}

export type ApiV1SettingsTestCallbackUrlRequest = ApiSettingsTestCallbackUrlRequest

export type ApiV2SettingsTestCallbackUrlRequest = {
  format: ApiSettingsTestCallbackUrlFormat
} & ApiSettingsTestCallbackUrlRequest

export type ApiSettingsTestCallbackUrlResponseData = {
  response: string
  code: string
  headers: string[]
}
export type ApiSettingsTestCallbackUrlResponse = {
  data: ApiSettingsTestCallbackUrlResponseData
}

export type ApiSettingsPasswordRequest = {
  accountPassword: string
}

export type ApiSettingsPasswordResponse = {
  password: string
}
